(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(wrapper) {
    if (wrapper.dataset.hcInitialized === 'true') return;
    wrapper.dataset.hcInitialized = 'true';

    var track = wrapper.querySelector('.hottest-collections-track');
    var prevBtn = wrapper.querySelector('.hottest-collections-arrow--prev');
    var nextBtn = wrapper.querySelector('.hottest-collections-arrow--next');

    if (!track) return;

    function slideAmount() {
      var slide = track.querySelector('.hottest-collections-slide');
      var gap = parseInt(getComputedStyle(track).columnGap || 16, 10);
      return slide ? slide.offsetWidth + gap : 300;
    }

    function atStart() {
      return track.scrollLeft <= 0;
    }

    function atEnd() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      return track.scrollLeft >= maxScroll;
    }

    function updateArrowState() {
      if (prevBtn) prevBtn.disabled = atStart();
      if (nextBtn) nextBtn.disabled = atEnd();
    }

    function goNext() {
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: slideAmount(), behavior: 'smooth' });
      }
    }

    function goPrev() {
      track.scrollBy({ left: -slideAmount(), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goPrev(); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goNext(); restartAutoplay(); });

    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();

    // --- Autoplay ---
    var autoplayEnabled = wrapper.dataset.autoplay === 'true';
    var autoplaySpeed = (parseFloat(wrapper.dataset.autoplaySpeed) || 5) * 1000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplayEnabled || prefersReducedMotion) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(goNext, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    function restartAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      startAutoplay();
    }

    if (autoplayEnabled && !prefersReducedMotion) {
      startAutoplay();

      wrapper.addEventListener('mouseenter', stopAutoplay);
      wrapper.addEventListener('mouseleave', startAutoplay);
      wrapper.addEventListener('touchstart', stopAutoplay, { passive: true });
      wrapper.addEventListener('touchend', startAutoplay);
      track.addEventListener('pointerdown', stopAutoplay);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    }

    // Allow the theme editor to tear down/restart cleanly if the section reloads again
    wrapper.hcTeardown = function () {
      stopAutoplay();
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hottest-collections-wrapper').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-initialize whenever the theme customizer injects/reloads this section
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Stop timers if the section is removed/reloaded in the customizer
  document.addEventListener('shopify:section:unload', function (event) {
    var wrapper = event.target.querySelector && event.target.querySelector('.hottest-collections-wrapper');
    if (wrapper && wrapper.hcTeardown) wrapper.hcTeardown();
  });
})();